<template>
    <div class="container">
      <div class="sri-yantra-print-wrapper">
        <div class="sri-yantra-print">
          <div class="sri-yantra" :style="cssVars" id="cv">
              <div class="layer-container">
                  <div v-for="item in Object.keys(layers)" :class="`layer ${item}`" :key="item">
                  <inline-svg 
                    :src="`${wpData.assets_path}/images/sri-yantra/${item}.svg`"
                  ></inline-svg>
                  </div>
              </div>
          </div>
        </div>
      </div>
        
        
        <div class="row print-preview-wrapper">
            <div class="col-12 col-md-8">
              <div class="position-relative print-preview-grid">
                <div class="sri-yantra-preview">
                  <div class="sri-yantra" :style="cssVars">
                      <div class="layer-container">
                          <div v-for="item in Object.keys(layers)" :class="`layer ${item}`" :key="item">
                          <inline-svg 
                            :src="`${wpData.assets_path}/images/sri-yantra/${item}.svg`"
                          ></inline-svg>
                          </div>
                      </div>
                  </div>
                </div>
                <table class="a4-table" cellspacing="0" cellpadding="0">
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                
              </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="mb-3">
                    <div class="mb-2">
                      <button v-if="!isLoading"  type="button" class="btn btn-primary btn-block" @click="handlePrint">🖨 Download</button>
                      <div v-else class="btn-loading">🖨 Processing...</div>
                    </div>
                    <button type="button" class="btn btn-light btn-block" @click="backPage">Back</button>
                </div>
                <div class="paper-detail">
                  Paper size: 21 x 29.7 cm<br>
                  Poster size: 84 x 84 cm<br>
                  Paper consumption: 12 sheets
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import InlineSvg from 'vue-inline-svg';
import { mapState } from 'vuex'

export default {
    components: {
        InlineSvg,
    },
    data () {
        return {
          wpData,
          isLoading: false,
            bgColor: '#fff',
            layers: {
                c1: '#fff',
                c2: '#fff',
                c3: '#fff',
                c4: '#fff',
                c5: '#fff',
                c6: '#fff',
                c7: '#fff',
                c8: '#fff',
                c9: '#fff',
                c10: '#fff',
                c11: '#fff',
                line: '#000',
            }
        }
    },
    computed: {
        ...mapState(['colors']),
        cssVars() {
        let _cssVars = {}
        _cssVars['--bg-color'] = this.colors.bgColor
        Object.keys(this.colors.layers).map(item => {
            _cssVars[`--${item}-color`] = this.colors.layers[item]
        });
        return _cssVars
        }
    },
    mounted() {
    },
    methods: {
        backPage: function() {
            this.$router.push('/')
        },
        genPDF: function() {
          
          const jsPDF = require('jspdf');
          var el = document.getElementById('cv');

          const computedStyleToInlineStyle = require("computed-style-to-inline-style");
          const svgElements = [...document.getElementsByTagName('svg')] ;
          
          svgElements.forEach(svgElement => {
            computedStyleToInlineStyle(svgElement, { 
              recursive: true,
              properties: ["stroke", "fill"] 
            });  
          });

          const html2canvas = require('html2canvas')
          //'2480 3508'
          const a4Width = 2480/2
          const a4Height = 3508/2

          let loadCanvas = []

          for (let row = 0; row < 3; row++ ) {
            for (let col = 0; col < 4; col++ ) {
                loadCanvas.push(
                  html2canvas(el,{
                    dpi: 300,
                    width: a4Width,
                    height: a4Height,
                    x: a4Width*col,
                    y: a4Height*row,
                  }).then(canvas => {
                    const img = canvas.toDataURL("image/jpeg",0.8);
                    return img
                  })
                )   
            }
          }

          Promise.all(loadCanvas).then((data)=>{
            
            var doc = new jsPDF("p", "mm", "a4");
            var width = doc.internal.pageSize.getWidth();
            var height = doc.internal.pageSize.getHeight();

            data.forEach((image, index)=> {
              doc.addImage(image, 'JPEG', 0, 0, width, height);
              if (index < data.length-1) {
                doc.addPage('a4', 'p')
              }
            })
            this.isLoading = false
            doc.save('sri-yantra.pdf');
          })
          
        },
        handlePrint: function() {
          this.isLoading = true
          setTimeout(()=>{
            this.genPDF()
          }, 0);
        }
    }
}
</script>

<style lang="scss">
.print-preview-wrapper{
  
}
.print-preview-grid{
  padding-top: 120%;
}
canvas{
  border: 1px solid #ccc;
}
svg{
  width: 100%;
  height: 100%;
}
.layer{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  rect#border{
    stroke: none;
  }
}
.sri-yantra-print-wrapper{
  width: 0;
  height: 0;
  left: 0;
  top: 0;
  overflow: hidden;
  position: absolute;
}

.sri-yantra{
  background: var(--bg-color);
  padding: 5%;
  width: 100%;
  position: relative;
}
.sri-yantra-preview{
  position: absolute;
  top:0;
  width: 100%;
}

.layer-container{
  position: relative;
  width: 100%;
  padding-top: 100%;
}
.sri-yantra-print{
  // position: absolute;
  // width: 9920px;
  width: 4960px;
  // width: 2480px;
  // width: 1652px;
  left: 0;
  top: 0;
  background: #fff;
  .sri-yantra{
    box-shadow: none;
  }
}
.a4-table{
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    line-height: 0;
    z-index: 1000;
    td{
        border: 1px solid #ccc;
        line-height: 0;
        &::before{
            content: '';
            display: block;
            width: 100%;
            position: relative;
            padding-top: 141.42%;    
        }
    }
}
.line{
  path{
    stroke: var(--line-color) !important;
  }
  polygon{
    stroke: var(--line-color) !important;
  }
}
.c1{
  polygon{
    fill: var(--c1-color) !important;
  }
}
.c2{
  polygon{
    fill: var(--c2-color) !important;
  }
}
.c3{
  polygon{
    fill: var(--c3-color) !important;
  }
}
.c4{
  polygon{
    fill: var(--c4-color) !important;
  }
}
.c5{
  polygon{
    fill: var(--c5-color) !important;
  }
}
.c6{
  path{
    fill: var(--c6-color) !important;
  }
  polygon{
    fill: var(--c6-color) !important;
  }
}
.c7{
  path{
    fill: var(--c7-color) !important;
  }
}
.c8{
  path{
    fill: var(--c8-color) !important;
  }
}
.c9{
  path{
    fill: var(--c9-color) !important;
  }
}
.c10{
  path{
    fill: var(--c10-color) !important;
  }
}
.c11{
  path{
    fill: var(--c11-color) !important;
  }
}
</style>
